import { useState, useCallback } from 'react'
import {
    getMaintenanceMode,
    getMaintenanceModeLink as fetchMaintenanceModeLink,
} from '../repositories/MiscRepository'
import useAuth from './useAuth'
import { DEFAULT_MAINTENANCE_MESSAGE } from '../constants/maintenanceCopy'

const useMisc = () => {
    const [isInMaintenanceMode, setIsInMaintenanceMode] = useState(false)
    const [isInMaintenanceModePage, setIsInMaintenanceModePage] = useState(
        false,
    )
    const [maintenanceModeMessage, setMaintenanceModeMessage] = useState(
        DEFAULT_MAINTENANCE_MESSAGE,
    )
    const [maintenanceModeLink, setMaintenanceModeLink] = useState({
        link: '',
        linkText: '',
        hasLink: false,
    })

    const {
        role,
        authenticated: isLoggedIn,
        impersonated: isImpersonated,
    } = useAuth()
    const isAdmin = isLoggedIn && role === 'admin'
    const isSalesperson = isLoggedIn && role === 'salesperson'
    const isElevatedUser = isAdmin || isSalesperson

    const getMaintenanceModeLink = useCallback(async () => {
        try {
            const response = await fetchMaintenanceModeLink()
            if (response && response.data) {
                setMaintenanceModeLink(response.data)
            }
        } catch (error) {
            console.error('Error fetching maintenance mode link:', error)
        }
    }, [])

    const getMaintenanceModeForPage = useCallback(() => {
        return getMaintenanceMode().then(data => {
            setIsInMaintenanceModePage(data.maintenance_mode)
            setMaintenanceModeMessage(data.message)
        })
    }, [])

    const checkMaintenanceMode = useCallback(
        onRedirectToHome => {
            if (!isLoggedIn || isElevatedUser || isImpersonated) {
                getMaintenanceModeForPage()
                setIsInMaintenanceMode(false)
                return
            }
            getMaintenanceMode().then(data => {
                setIsInMaintenanceMode(data.maintenance_mode)
                setMaintenanceModeMessage(data.message)
                if (onRedirectToHome && !data.maintenance_mode) {
                    onRedirectToHome()
                }
            })
        },
        [isLoggedIn, isElevatedUser, isImpersonated, getMaintenanceModeForPage],
    )

    return {
        isInMaintenanceMode,
        isInMaintenanceModePage,
        maintenanceModeMessage,
        maintenanceModeLink,
        checkMaintenanceMode,
        setIsInMaintenanceMode,
        getMaintenanceModeForPage,
        getMaintenanceModeLink,
    }
}

export default useMisc
